import type { ComponentCommonBullet } from '@edwin-group/cj-graphql/generated/graphql';
import classNames from 'classnames';

export default function DefaultContentTemplateBullets({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonBullet;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <ul
      className={classNames('ml-4 list-disc', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      {component.item.map((item, index) => (
        <li key={index}>
          <span className="text-sh-sm">{item?.text}</span>
        </li>
      ))}
    </ul>
  );
}
